let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kQYS0")).then(() => parcelRequire('eOyqU'));